import React from 'react';

const Brackets: React.FC = () => (
  <svg className="brackets" preserveAspectRatio="none" viewBox="0 0 612.74 357.15">
    <path d="M612.74 357.15h-78v-17.93h19.46q11.68 0 16.62-2.33a11.33 11.33 0 0 0 6.37-7.6q1.41-5.27 1.42-16.76V45.2q0-11.3-1.12-16.46A11.15 11.15 0 0 0 571 21q-5.32-2.64-16.85-2.63h-19.42V0h78zM0 0h78v17.93H58.55q-11.69 0-16.62 2.33a11.33 11.33 0 0 0-6.37 7.6q-1.41 5.27-1.42 16.76V312q0 11.3 1.12 16.46a11.15 11.15 0 0 0 6.44 7.79q5.32 2.64 16.85 2.63H78v18.32H0z" />
  </svg>
);

export default Brackets;
